export default {
  page_home: {
    mock_tit: "社科赛斯模考",
  },
};
